import { useMutation } from "@apollo/client";
import UPDATE_FAILED_PAYMENT_FOR_USER from "queries/updateFailedPaymentForUser.gql";
import { useState } from "react";
import { logGqlErrorToSentry } from "utils/sentry";

const useUpdateBlockPayments = () => {
  const [error, setError] = useState();
  const [mutate, { loading }] = useMutation(
    UPDATE_FAILED_PAYMENT_FOR_USER,
    { errorPolicy: "all" },
  );

  return {
    updateBlockPayments: (email, context = []) => {
      mutate({ variables: { input: { email, context: JSON.stringify(context) } } })
        .then((result) => {
          if (result.errors?.length) {
            logGqlErrorToSentry(result.errors[0], "Could not block payments for user");
            setError(result.errors[0]);
          }
        });
    },
    loading,
    error,
  };
};

export default useUpdateBlockPayments;
